import { Badge } from '@kcd/design-system';
import { trackEvent } from '@kcd/event-tracker';

import PlacementRenderer from '~/domains/mmp/components/PlacementRenderer';
import { usePlacementSearchKeywords } from '~/domains/mmp/queries';
import { useUpdateRouterQuery } from '~/hooks/url';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';
import { openModal } from '~/utils/mobileApp';

export function AdRecommendKeywordList() {
  const updateRouterQuery = useUpdateRouterQuery();
  const { businessId } = useBusinessIdStore();

  const { data } = usePlacementSearchKeywords(
    businessId,
    'market_search_keyword',
  );

  const onClick = ({
    keyword,
    landingUrl,
  }: {
    keyword: string;
    landingUrl: string;
  }) => {
    trackEvent('clicked tab in 마켓/검색', {
      keyword,
      clicked_area: '추천 검색어',
    });

    const queryString = landingUrl.split('?')[1];
    const params = new URLSearchParams(queryString).get('searchText');

    if (params) {
      void updateRouterQuery({ searchText: params });
    } else {
      void openModal({ url: landingUrl });
    }
  };

  if (!data?.length) return <></>;

  return (
    <div>
      <div className="mb-12 flex items-center justify-between px-20 text-paragraph typo-caption100-regular">
        <h2 className="typo-caption100-semibold">추천 검색어</h2>
        <span className="text-gray-600 typo-footnote100-regular">AD</span>
      </div>
      <div className="grid grid-flow-row grid-cols-3 gap-8 px-20">
        {data.map((item) => {
          const { keyword, isNew } = item;

          return (
            <span
              role="presentation"
              key={keyword}
              className="relative"
              onClick={() => onClick(item)}
            >
              <PlacementRenderer {...item}>
                <span
                  role="presentation"
                  className="inline-block !w-full rounded-16 border border-solid border-primary-regular px-12 py-[5px] text-center !text-primary-regular !ring-[var(--colors-blue-600)] typo-paragraph100-semibold"
                >
                  {keyword}
                  {isNew && (
                    <Badge
                      type="new"
                      className="absolute right-0 top-0 -mr-6 -mt-8"
                    />
                  )}
                </span>
              </PlacementRenderer>
            </span>
          );
        })}
      </div>
    </div>
  );
}
